import React, { Component } from 'react'
import { Provider, inject, observer } from "mobx-react"
import { Layout, Menu, Icon, Breadcrumb, Button, message } from 'antd'
import Profile from '../layoutComponents/Profile'
import HeaderCategories from '../layoutComponents/HeaderCategories'
import CoreApp from './CoreApp'
import CustomRouter from '../../stores/CustomRouter';
import NavViews from '../../stores/NavViews';
import HeaderComponent from '../layoutComponents/Header'
import LoginModal from '../modals/LoginModal'
import jwtDecode from 'jwt-decode'
import BetSlip from './BetSlip'
import AgreeToTermsModal from '../modals/AgreeToTermsModal'
import WelcomeCardModal from '../modals/WelcomeCardModal';
import Web3NotInstalled from '../web3Components/web3NotInstalled';
import Casino from "./Casino";
import { FaEthereum, FaDice, FaDiceThree } from 'react-icons/fa';
import Web3NoContract from '../web3Components/web3NoContract';
const LS_KEY = 'mm-login-demo:auth';

@observer(["web3Store", "contractStore", "ViewStore", "AuthStore", "AdminStore", "UserStore", "CustomRouter", "CategoriesStore"])
class AppContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newNumber: 1,
      showWelcome: false
    };

    this.handleHeader = this.handleHeader.bind(this);
    this.handleEventsClick = this.handleEventsClick.bind(this);
    this.isMenuItemSelected = this.isMenuItemSelected.bind(this);
    this.checkLogin = this.checkLogin.bind(this);
  }

  async componentDidMount() {
    const { contractStore, ViewStore, AdminStore, UserStore } = this.props;
    //const month = await contractStore.call("Mevu", "newMonth", []);
    //console.log(month);
    let self = this;

    AdminStore.getOraclePeriod().then((response) => {
      self.setState({ oraclePeriod: response });
    });

    //AdminStore.getOracleStatus() //todo get the oracle status and pass to admin store, can check oracle status anywhere
    //
    AdminStore.getOracleStatus().then((response) => {
      self.setState({ oracleStatus: response });
    });

    UserStore.getMvuBalance().then((response) => {
      self.setState({ mvuBalance: response });
    });
    //
    //
    //
    //
    //
    //
    //
    ////////////////////////////////////////////////////////////////////////////
  }

  checkLogin() {
    const { auth: { accessToken } } = this.state;
    let tokenObject = jwtDecode(accessToken);
    let now = new Date().getTime() / 1000;
    // console.log("expired: " + JSON.stringify(tokenObject));
    // console.log("now: " + now);
    if (tokenObject.exp <= now) {
      message.info("Session has expired, logging you out...");
      this.handleLoggedOut();
    }
  }

  componentWillMount() {
    const { CategoriesStore } = this.props;
    CategoriesStore.queryCategories();
    // Access token is stored in localstorage
    //console.log("LS: " + localStorage.getItem(LS_KEY));
    let auth;
    let welcome = false;
    if (localStorage !== null) {
      if (localStorage.getItem(LS_KEY) !== null) {
        auth = JSON.parse(localStorage.getItem(LS_KEY));
      }
    }
    if (auth) {
      welcome = true;
    }
    this.setState({
      auth,
      showWelcome: welcome
    });
    this.props.AuthStore.authUser(auth);
  }

  handleEventsClick() {
    this.props.ViewStore.changeView('MOBX!');
  }

  handleLoggedIn = auth => {
    localStorage.setItem(LS_KEY, JSON.stringify(auth));
    this.setState({ auth, showWelcome: true });
    this.props.AuthStore.authUser(auth);
    this.props.AdminStore.getOracleStatus();
  };

  handleLoggedOut = () => {
    localStorage.removeItem(LS_KEY);
    this.setState({ auth: undefined, showWelcome: false });
    this.props.AuthStore.authUser(undefined)
  };

  handleHeader() {
    this.props.ViewStore.changeHeaderState();
  }

  isMenuItemSelected(view) {
    if (localStorage !== null) {
      if (localStorage.getItem(LS_KEY) !== null) {
        this.checkLogin()
      }
    }
    return this.props.ViewStore.activeView === view;
  }

  render() {
    const { Content, Footer, Sider } = Layout;
    const { auth } = this.state;
    const SideBarMenuItem = ({ value, text, icon, onClick, isMenuItemSelected }) => {
      return (
        <li className={(isMenuItemSelected(value) ? 'ant-menu-item ant-menu-item-selected' : 'ant-menu-item')} role="menuitem" style={{ paddingLeft: '24px' }} value={value} onClick={() => onClick(value)}>
          <Icon style={{ fontSize: "14pt" }} type={icon} />
          <span style={{ fontSize: "14pt" }} className="nav-text">{text}</span>
        </li>
      )
    };
    const { CustomRouter } = this.props;
    const { router: { goTo } } = CustomRouter;
    const { Header } = Layout;
    return (
      <Provider>
        {this.props.web3Store.network !== 1 ?
          <Layout>
            {this.props.AdminStore.actionAttemptedNoWeb3 ? <div>
              <div className="help-modal-content-header-close-btn" onClick={this.props.AdminStore.closeNoWeb3Modal}><Icon type="close-circle" /></div><Web3NotInstalled />

            </div> : ""}
            {this.state.showWelcome ? (
              <div>
                <WelcomeCardModal />
                <AgreeToTermsModal />
              </div>
            ) : (
                <span></span>
              )}
            <Header>
              <div className="logo" onClick={() => CustomRouter.router.goTo(NavViews.home)}>
                <img src={require('../../assets/img/logo.svg')} width="120px" />
                <div className="slogan">BETTING REDEFINED.</div>
              </div>
              {auth ? (
                <Profile auth={auth} onLoggedOut={this.handleLoggedOut} />
              ) : (
                  <span></span>
                )}
              {auth ? (
                <div className="header-logout-button">
                  <pre><button className="custom-btn-danger" data-toggle="tooltip" data-placement="left" title="logout" onClick={this.handleLoggedOut}><Icon type="logout" /></button></pre>
                </div>
              ) : (
                  <div className="header-login-button">
                    <LoginModal onLoggedIn={this.handleLoggedIn} />
                  </div>
                )}
            </Header>
            <Layout>
              <Sider style={{
                flex: '0 0 250px',
                maxWidth: '250px',
                minWidth: '250px',
                width: '250px'
              }}
                collapsedWidth="0"
                breakpoint="lg"
                onBreakpoint={(broken) => {
                  console.log("CLOSED");

                }}
                onCollapse={(collapsed, type) => {
                  this.handleHeader();
                }}
              >
                <div className="sidebar-scroll-menu">

                  <Menu
                    theme="dark"
                    mode="inline"

                  >
                    <SideBarMenuItem value="Events" text="Events" icon="calendar" isMenuItemSelected={this.isMenuItemSelected} onClick={() => {
                      this.props.AdminStore.diceRolling || this.props.AdminStore.coinFlipping ? message.info("Wait for dice roll or coin flip to finish") : CustomRouter.router.goTo(NavViews.home)
                    }} />
                    {/* <li className={(this.isMenuItemSelected("Casino") ? 'ant-menu-item ant-menu-item-selected' : 'ant-menu-item')} role="menuitem" style={{ paddingLeft: '24px' }} value={"Casino"}
                      onClick={() => {
                        this.props.AdminStore.diceRolling || this.props.AdminStore.coinFlipping
                          ? message.info("Wait for dice roll or coin flip to finish") : CustomRouter.router.goTo(NavViews.casino)
                      }}>
                      <FaDiceThree style={{ fontSize: "14pt" }} /> <span style={{ fontSize: "14pt" }} className="nav-text">  Casino</span>
                    </li> */}
                    {this.props.UserStore.user.role == "admin" ?
                      <SideBarMenuItem value="Expired Events" text="Expired Events" icon="hourglass" isMenuItemSelected={this.isMenuItemSelected} onClick={() => {
                        this.props.AdminStore.diceRolling || this.props.AdminStore.coinFlipping ?
                          message.info("Wait for dice roll or coin flip to finish") : CustomRouter.router.goTo(NavViews.expiredEvents)
                      }} /> : null}
                    <SideBarMenuItem value="My Bets" text="My Bets" icon="database" isMenuItemSelected={this.isMenuItemSelected}
                      onClick={() => {
                        this.props.AdminStore.diceRolling || this.props.AdminStore.coinFlipping ?
                          message.info("Wait for dice roll or coin flip to finish") : CustomRouter.router.goTo(NavViews.myBets)
                      }} />
                    <SideBarMenuItem value="Oracles" text="Oracles" icon="safety" isMenuItemSelected={this.isMenuItemSelected}
                      onClick={() => {
                        this.props.AdminStore.diceRolling || this.props.AdminStore.coinFlipping ?
                          message.info("Wait for dice roll or coin flip to finish") : CustomRouter.router.goTo(NavViews.oracles)
                      }} />
                    <SideBarMenuItem value="Watchlist" text="Watch" icon="eye" isMenuItemSelected={this.isMenuItemSelected}
                      onClick={() => {
                        this.props.AdminStore.diceRolling || this.props.AdminStore.coinFlipping ?
                          message.info("Wait for dice roll or coin flip to finish") : CustomRouter.router.goTo(NavViews.watchlist)
                      }} />
                    <SideBarMenuItem value="Custom Bets" text="Custom" icon="book" isMenuItemSelected={this.isMenuItemSelected}
                      onClick={() => {
                        this.props.AdminStore.diceRolling || this.props.AdminStore.coinFlipping ?
                          message.info("Wait for dice roll or coin flip to finish") : CustomRouter.router.goTo(NavViews.customBets)
                      }} />
                    <SideBarMenuItem value="Leaderboard" text="Leaders" icon="trophy" isMenuItemSelected={this.isMenuItemSelected}
                      onClick={() => {
                        this.props.AdminStore.diceRolling || this.props.AdminStore.coinFlipping ?
                          message.info("Wait for dice roll or coin flip to finish") : CustomRouter.router.goTo(NavViews.leaderBoard)
                      }} />
                    <SideBarMenuItem value="My Stats" text="Stats" icon="fund" isMenuItemSelected={this.isMenuItemSelected}
                      onClick={() => { this.props.AdminStore.diceRolling || this.props.AdminStore.coinFlipping ? message.info("Wait for dice roll or coin flip to finish") : CustomRouter.router.goTo(NavViews.myStats) }} />
                    {this.props.UserStore.user.role == "admin" ?
                      <SideBarMenuItem value="Admin" text="Admin" icon="crown" isMenuItemSelected={this.isMenuItemSelected}
                        onClick={() => {
                          this.props.AdminStore.diceRolling || this.props.AdminStore.coinFlipping ?
                            message.info("Wait for dice roll or coin flip to finish") : CustomRouter.router.goTo(NavViews.admin)
                        }} /> : null}
                  </Menu>

                </div>

              </Sider>
              <Layout>
                <Content>
                  <div className="main-content">
                    {/* <HeaderCategories /> */}
                    <Breadcrumb style={{ margin: '20px 0px 10px 0px' }}>
                      <Breadcrumb.Item>Home</Breadcrumb.Item>
                      <Breadcrumb.Item>{this.props.ViewStore.activeView}</Breadcrumb.Item>
                      {this.props.AdminStore.singleEventViewActive ?    <Breadcrumb.Item>{this.props.AdminStore.eventCrumbs}</Breadcrumb.Item> : null}
                    </Breadcrumb>
                    {/* <span style={{marginLeft: "15%", fontSize: "18pt"}}> UPDATING SMART-CONTRACTS, THIS COULD TAKE A FEW HOURS, PLEASE CHECK BACK SOON</span>
                  <br />
                  <Icon style={{marginLeft: "45%", fontSize: "60pt"}} type="cloud-upload" /> */}
                    <CoreApp />
                  </div>
                  <div style={{ textAlign: 'center' }} ><img width={"128px"} src={require('../../assets/img/built_on_eth.png')} /></div>
                  <BetSlip />
                  <Footer>
                    MEVU ©2017 - {new Date().getUTCFullYear()}
                  </Footer>
                </Content>
              </Layout>
            </Layout>
          </Layout>
          :

          <div style={{ overflow: "auto" }}>
            <div className="logo" >
              <img src={require('../../assets/img/logo.svg')} width="120px" />
              <div className="slogan">BETTING REDEFINED.</div>
            </div>
            <Casino />
            <div style={{ textAlign: 'center' }} ><img width={"128px"} src={require('../../assets/img/built_on_eth.png')} /></div>
            <Footer>
              MEVU ©2017 - {new Date().getUTCFullYear()}
            </Footer>
          </div>}
      </Provider>
    )
  }
}

export default AppContent;



// WEBPACK FOOTER //
// ./src/components/appComponents/appContent.js